import axios from 'axios'

class DocumentoEditorTextoApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async inserir(documentoEditorTextoModel) {
		return await axios.post(this.urlBuilder.editorTexto.getUrlInserir(), documentoEditorTextoModel)
	}

	async redigir(idDocumento) {
		return await axios.put(this.urlBuilder.editorTexto.getUrlRedigir(idDocumento))
	}

	async visualizar(idDocumento) {
		return await axios.get(this.urlBuilder.editorTexto.getUrlVisualizar(idDocumento))
	}

	async concluirDocumento(idDocumento) {
		return await axios.put(this.urlBuilder.editorTexto.getUrlConcluirDocumento(idDocumento))
	}

	async buscarPorId(idDocumento) {
		return await axios.get(this.urlBuilder.editorTexto.getUrlBuscarPorId(idDocumento))
	}

	async sincronizarDocumento(idDocumento) {
		return await axios.put(this.urlBuilder.editorTexto.getUrlSincronizar(idDocumento))
	}
}

export default DocumentoEditorTextoApiClient
